import React from "react";
import styled from "styled-components";

const CSSValueStyles = styled.footer`
  width: 100%;
  text-align: center;
  h1 {
  }
`;

function CSSValue({ points }) {
  return (
    <CSSValueStyles>
      <div
        style={{
          border: "1px dotted black",
          borderRadius: "10px",
          margin: "1em",
          padding: "0.2em 1.5em",
        }}
      >
        <p style={{ textAlign: "left" }}>
          <strong>clip-path:</strong> {points};
        </p>
      </div>
    </CSSValueStyles>
  );
}

export default CSSValue;
